import React, {useState, useContext, useEffect} from 'react'
import {Redirect} from 'react-router-dom'
import {Context} from '../Data/Context/Context'
import {AlertContext} from '../Data/Context/Alert/AlertContext'
import {PG_REST_URL} from "../Data/Constants"

function sha512(str) {
    return crypto.subtle.digest("SHA-512", new TextEncoder("utf-8").encode(str)).then(buf => {
        return Array.prototype.map.call(new Uint8Array(buf), x => ('00' + x.toString(16)).slice(-2)).join('');
    });
}

function generateSalt() {
    const arr = new Uint8Array(16)
    crypto.getRandomValues(arr)
    return Array.prototype.map.call(arr, x => ('00' + x.toString(16)).slice(-2)).join('')
}

export default function AdminPage(props) {
    const {getUserCreds} = useContext(Context)
    const {show} = useContext(AlertContext)
    const [searchTerm, setSearchTerm] = useState('')
    const [users, setUsers] = useState([])
    const [loading, setLoading] = useState(false)

    const [showCreate, setShowCreate] = useState(false)
    const [newEmail, setNewEmail] = useState('')
    const [newPass, setNewPass] = useState('')
    const [newPhone, setNewPhone] = useState('')
    const [newPrice, setNewPrice] = useState(0)
    const [newAdmin, setNewAdmin] = useState(false)
    const [dbVerified, setDbVerified] = useState(false)

    useEffect(() => {
        async function verifyAdmin() {
            try {
                const res = await fetch(PG_REST_URL + '/tab_users?email=eq.' + encodeURIComponent(getUserCreds().user), {})
                if (!res.ok) return
                const data = await res.json()
                setDbVerified(data.length > 0 && data[0].is_admin === true)
            } catch {}
        }
        verifyAdmin()
    }, [getUserCreds])

    if (!getUserCreds().isAdmin || !dbVerified) {
        if (getUserCreds().user && !dbVerified) {
            return <div style={{padding: '20px'}}><h2>Проверка прав доступа...</h2></div>
        }
        return <Redirect to="/" />
    }

    const createUser = async () => {
        if (!newEmail) {
            show('Введите email', 'warning')
            return
        }
        try {
            const salt = newPass ? generateSalt() : null
            const hash = newPass ? await sha512(salt + newPass) : null
            const response = await fetch(PG_REST_URL + '/tab_users', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Prefer: 'return=representation',

                },
                body: JSON.stringify({
                    email: newEmail,
                    password: hash,
                    salt,
                    phone: newPhone || '',
                    PriceNo: newPrice,
                    is_admin: newAdmin
                })
            })
            if (!response.ok) throw new Error('HTTP ' + response.status)
            await response.json()
            setNewEmail('')
            setNewPass('')
            setNewPhone('')
            setNewPrice(0)
            setNewAdmin(false)
            setShowCreate(false)
            show('Пользователь ' + newEmail + ' создан', 'success')
            searchUsers()
        } catch (e) {
            show('Ошибка создания: ' + e.message, 'error')
        }
    }

    const searchUsers = async () => {
        setLoading(true)
        try {
            const url = searchTerm
                ? PG_REST_URL + '/tab_users?email=ilike.*' + encodeURIComponent(searchTerm) + '*&order=email'
                : PG_REST_URL + '/tab_users?order=email'
            const response = await fetch(url,
                {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
    
                    }
                }
            )
            const data = await response.json()
            setUsers(data)
            if (data.length === 0) {
                show('Пользователи не найдены', 'warning')
            }
        } catch (e) {
            show('Ошибка поиска: ' + e.message, 'error')
        } finally {
            setLoading(false)
        }
    }

    const updateUser = async (email, newPriceNo, newPhone) => {
        try {
            const body = {};
            if (newPriceNo !== undefined) body.PriceNo = newPriceNo;
            if (newPhone !== undefined) body.phone = newPhone;
            const response = await fetch(
                PG_REST_URL + '/tab_users?email=eq.' + encodeURIComponent(email),
                {
                    method: 'PATCH',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        Prefer: 'return=representation',
    
                    },
                    body: JSON.stringify(body)
                }
            )
            if (!response.ok) throw new Error('HTTP ' + response.status)
            await response.json()
            setUsers(prev => prev.map(u =>
                u.email === email ? {...u, ...body} : u
            ))
            show('Пользователь ' + email + ' обновлён', 'success')
        } catch (e) {
            show('Ошибка сохранения: ' + e.message, 'error')
        }
    }

    return (
        <div style={{padding: '20px'}}>
            <h2>Администрирование пользователей</h2>
            <div style={{marginBottom: '20px', display: 'flex', gap: '10px'}}>
                <input
                    type="text"
                    placeholder="Поиск по email..."
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                    onKeyDown={e => e.key === 'Enter' && searchUsers()}
                    style={{padding: '8px', fontSize: '16px', flex: 1, maxWidth: '400px'}}
                />
                <button onClick={searchUsers} disabled={loading} style={{padding: '8px 16px'}}>
                    {loading ? 'Поиск...' : 'Найти'}
                </button>
            </div>

            <div style={{marginBottom: '20px'}}>
                <button
                    onClick={() => setShowCreate(!showCreate)}
                    style={{padding: '8px 16px', cursor: 'pointer'}}
                >
                    {showCreate ? 'Отмена' : 'Создать пользователя'}
                </button>
            </div>

            {showCreate && (
                <div style={{marginBottom: '20px', padding: '16px', border: '1px solid #ccc', maxWidth: '500px'}}>
                    <div style={{marginBottom: '8px'}}>
                        <input type="text" placeholder="Email" value={newEmail}
                            onChange={e => setNewEmail(e.target.value)}
                            style={{padding: '6px', width: '100%', boxSizing: 'border-box'}} />
                    </div>
                    <div style={{marginBottom: '8px'}}>
                        <input type="password" placeholder="Пароль (если не указать — вход только по Google)" value={newPass}
                            onChange={e => setNewPass(e.target.value)}
                            style={{padding: '6px', width: '100%', boxSizing: 'border-box'}} />
                    </div>
                    <div style={{marginBottom: '8px'}}>
                        <input type="text" placeholder="Телефон" value={newPhone}
                            onChange={e => setNewPhone(e.target.value)}
                            style={{padding: '6px', width: '100%', boxSizing: 'border-box'}} />
                    </div>
                    <div style={{marginBottom: '8px', display: 'flex', gap: '16px', alignItems: 'center'}}>
                        <label>PriceNo:
                            <select value={newPrice} onChange={e => setNewPrice(Number(e.target.value))}
                                style={{padding: '4px', marginLeft: '6px'}}>
                                {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(p => (
                                    <option key={p} value={p}>{p}</option>
                                ))}
                            </select>
                        </label>
                        <label>
                            <input type="checkbox" checked={newAdmin}
                                onChange={e => setNewAdmin(e.target.checked)} style={{marginRight: '4px'}} />
                            Админ
                        </label>
                    </div>
                    <button onClick={createUser} style={{padding: '8px 16px', cursor: 'pointer'}}>
                        Сохранить
                    </button>
                </div>
            )}

            {users.length > 0 && (
                <table style={{borderCollapse: 'collapse', width: '100%', maxWidth: '800px'}}>
                    <thead>
                        <tr style={{backgroundColor: '#f0f0f0', textAlign: 'left'}}>
                            <th style={{padding: '8px', border: '1px solid #ccc'}}>Email</th>
                            <th style={{padding: '8px', border: '1px solid #ccc'}}>Телефон</th>
                            <th style={{padding: '8px', border: '1px solid #ccc'}}>PriceNo</th>
                            <th style={{padding: '8px', border: '1px solid #ccc'}}>Админ</th>
                            <th style={{padding: '8px', border: '1px solid #ccc'}}>Действие</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map(user => (
                            <UserRow key={user.email} user={user} onSave={updateUser} />
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    )
}

function UserRow({user, onSave}) {
    const [selectedPrice, setSelectedPrice] = useState(user.PriceNo)
    const [phone, setPhone] = useState(user.phone || '')
    const changed = selectedPrice !== user.PriceNo || phone !== (user.phone || '')

    return (
        <tr>
            <td style={{padding: '8px', border: '1px solid #ccc'}}>{user.email}</td>
            <td style={{padding: '8px', border: '1px solid #ccc'}}>
                <input
                    type="text"
                    value={phone}
                    onChange={e => setPhone(e.target.value)}
                    style={{padding: '4px', width: '150px'}}
                />
            </td>
            <td style={{padding: '8px', border: '1px solid #ccc'}}>{user.PriceNo}</td>
            <td style={{padding: '8px', border: '1px solid #ccc'}}>{user.is_admin ? 'Да' : 'Нет'}</td>
            <td style={{padding: '8px', border: '1px solid #ccc'}}>
                <select
                    value={selectedPrice}
                    onChange={e => setSelectedPrice(Number(e.target.value))}
                    style={{padding: '4px', marginRight: '8px'}}
                >
                    {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(p => (
                        <option key={p} value={p}>Price {p}</option>
                    ))}
                </select>
                <button
                    onClick={() => onSave(user.email, selectedPrice, phone)}
                    disabled={!changed}
                    style={{padding: '4px 12px'}}
                >
                    Сохранить
                </button>
            </td>
        </tr>
    )
}
